import { ReactNode } from 'react';

import styles from './presenceSectionWarning.module.scss';

type PresenceSectionWarningProps = {
  title: string | ReactNode;
  message?: ReactNode;
};

export const PresenceSectionWarning = ({
  title,
  message,
}: PresenceSectionWarningProps): JSX.Element => (
  <li>
    <h3 className={styles.emptyListItemHead}>{title}</h3>
    {message && <p className={styles.emptyListItemText}>{message}</p>}
  </li>
);
